import * as H from "history";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import ApiService from "../../../ApiService";
import MailroomConfigure from "../../../mailroom/MailroomConfigure";
import MailroomSchool from "../../../mailroom/MailroomSchool";
import SchoolPageTitle from "../../../SchoolPageTitle";
import AdminSchoolMenu from "../../../AdminSchoolMenu";

interface SalamanderConfigPageProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
}

interface SalamanderConfigPageState {

}

class SalamanderConfigPage extends Component<SalamanderConfigPageProps & DispatchProps, SalamanderConfigPageState> {

    constructor(props: SalamanderConfigPageProps & DispatchProps) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Mailroom Configure" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <MailroomSchool schoolCode={this.props.schoolCode} tenantId={this.props.tenantId} />
                <MailroomConfigure schoolCode={this.props.schoolCode} tenantId={this.props.tenantId} />
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): SalamanderConfigPageProps => {

        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,

            apiService: state.auth.apiService
        };
    }
)(SalamanderConfigPage);